import { makeAutoObservable } from 'mobx'

import RootStore from './root'

export class CommonStore {
  rootStore: RootStore
  activeTab = 'home'
  isShowTab = false
  isLoading = false
  appVersion = ''
  buildNumber = ''
  invalidAccess = false

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  setIsLoading = (loading: boolean) => {
    this.isLoading = loading
  }

  // 하단 tab 표시 여부 설정
  setShowTab = (isShowTab: boolean) => {
    this.isShowTab = isShowTab
  }

  setActiveTab = (category: string) => {
    this.activeTab = category
  }

  setBuildNumber = (buildNumber: string) => {
    this.buildNumber = buildNumber
  }

  setAppVersion = (appVersion: string) => {
    this.appVersion = appVersion
  }

  setInvalidAccess = (access: boolean) => {
    this.invalidAccess = access
  }
}
